import React, { useMemo, useEffect, useState } from "react";
import TableContainer from "../../components/Common/TableContainer";
import { useNavigate } from "react-router-dom";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import {
  Container,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Input,
  Label,
} from "reactstrap";
import { Button } from "reactstrap";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";
import { AvField, AvForm } from "availity-reactstrap-validation";
import {
  DeleteCacelation,
  FetchCacelations as fetchCancelationsFromAPI,
  UpdateCacelation,
} from "../../apis/CancelationPolicy";
import { AxiosError } from "axios";

const CancelationPolicy = () => {
  const [Cancelations, setCancelations] = useState([]);
  const [updateData, setUpdateData] = useState({
    cancellationPolicyId: "",
    itemName: "",
    itemContent: "",
    isChecked: true,
  });
  const [deleteData, setDeleteData] = useState({
    cancellationPolicyId: "",
  });
  const [modal_standard, setModal_standard] = useState(false);
  const [modal_static, setModal_static] = useState(false);

  const tog_standard = () => setModal_standard((prev) => !prev);
  const tog_static = () => setModal_static((prev) => !prev);
  const navigate = useNavigate();

  const fetchCancelations = async () => {
    const response = await fetchCancelationsFromAPI(); // Use the renamed function
    setCancelations(response.data.cancellationPolicies);
  };

  useEffect(() => {
    fetchCancelations(); // Call the renamed function
  }, []);

  const handleUpdate = async () => {
    try {
      const { cancellationPolicyId, itemName, itemContent, isChecked } =
        updateData;
      const updateCancelation = await UpdateCacelation(
        cancellationPolicyId,
        itemName,
        itemContent,
        isChecked ? "enabled" : "disabled",
      );
      if (updateCancelation) {
        toast.success("Cancelation Type Updated Successfully");
        setModal_standard(false);
        fetchCancelations();
      } else {
        toast.error("Cancelation policy update failed");
      }
    } catch (error) {
      if (error instanceof AxiosError) {
        toast.error(error.response.data.message);
      } else {
        toast.error("An unexpected error occurred. Please try again later.");
      }
    }
  };

  const handleDelete = async () => {
    try {
      const { cancellationPolicyId } = deleteData;
      const response = await DeleteCacelation(cancellationPolicyId);
      if (response) {
        toast.success("Cancellation Policy Type Deleted Successfully");
        setModal_static(false);
        fetchCancelations();
        navigate("/cancelation-policy");
      } else {
        toast.error("Cancelation policy deletion failed");
      }
    } catch (error) {
      if (error instanceof AxiosError) {
        toast.error(error.response.data.message);
      } else {
        toast.error("An unexpected error occurred. Please try again later.");
      }
    }
  };

  const columns = useMemo(
    () => [
      {
        Header: "English Item Name",
        accessor: "itemName.en",
      },
      {
        Header: "Arabic Item Name",
        accessor: "itemName.ar",
      },
      {
        Header: "English Item Content",
        accessor: "itemContent.en",
      },
      {
        Header: "Arabic Item Content",
        accessor: "itemContent.ar",
      },
      {
        Header: "Status",
        accessor: "status",
        Cell: ({ value }) => (value === "enabled" ? "Active" : "Inactive"),
      },
      {
        Header: "Created At",
        accessor: "createdAt",
        Cell: ({ value }) => new Date(value).toLocaleDateString(),
      },
      {
        Header: "Action",
        accessor: "actions",
        Cell: ({ row }) => (
          <div>
            <Button
              color="primary"
              className="btn-icon"
              onClick={() => handleEditClick(row.original)}
            >
              <i className="mdi mdi-pencil"></i>
            </Button>
            <Button
              color="danger"
              className="btn-icon"
              onClick={() => handleDeleteClick(row.original)}
            >
              <i className="mdi mdi-delete"></i>
            </Button>
          </div>
        ),
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );

  const handleEditClick = (CancelationPolicy) => {
    setUpdateData({
      cancellationPolicyId: CancelationPolicy._id,
      itemName: CancelationPolicy.itemName,
      itemContent: CancelationPolicy.itemContent,
      isChecked: CancelationPolicy.status === "enabled",
    });
    tog_standard(); // Open the modal
  };

  const handleDeleteClick = (CancelationPolicy) => {
    setDeleteData({
      cancellationPolicyId: CancelationPolicy._id,
    });
    tog_static(); // Open the modal
  };

  const breadcrumbItems = [
    { title: "Dashboard", link: "/" },
    { title: "Cancelation Policy", link: "#" },
  ];

  return (
    <React.Fragment>
      <div className="page-content">
      <Container className="px-0" fluid>
        <Breadcrumbs title="DATA TABLES" breadcrumbItems={breadcrumbItems} />
        <div className="p-6 flex flex-col gap-6 ">
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Button
              color="success"
              className="waves-effect waves-light me-1"
              onClick={() => navigate("/cancelation-policy/add")}
            >
              Add Cancelation Policy
            </Button>
          </div>
          <TableContainer
            columns={columns || []}
            data={Cancelations || []}
            isPagination={false}
            isCustomPageSize={false}
            isBordered={false}
            customPageSize={10}
          />
        </div>

        {/* START: Modal EDIT  */}
        <Modal isOpen={modal_standard} toggle={tog_standard}>
          <ModalHeader toggle={tog_standard}>Modal Heading</ModalHeader>
          <ModalBody>
            <AvForm onValidSubmit={handleUpdate}>
              <div className="mb-3">
                <AvField
                  name="itemNameEn"
                  label="Cancelation Policy Name In English"
                  placeholder="Type Something In English"
                  type="text"
                  errorMessage="Enter Name In English"
                  value={updateData.itemName.en}
                  validate={{ required: { value: true } }}
                  onChange={(e) =>
                    setUpdateData({
                      ...updateData,
                      itemName: {
                        en: e.target.value,
                        ar: updateData.itemName.ar,
                      },
                    })
                  }
                />
              </div>
              <div className="mb-3">
                <AvField
                  name="itemNameAr"
                  label="Cancelation Policy Name In Arabic"
                  placeholder="Type Something In Arabic"
                  type="text"
                  errorMessage="Enter Name In Arabic"
                  value={updateData.itemName.ar}
                  validate={{ required: { value: true } }}
                  onChange={(e) =>
                    setUpdateData({
                      ...updateData,
                      itemName: {
                        en: updateData.itemName.en,
                        ar: e.target.value,
                      },
                    })
                  }
                />
              </div>

              <div className="mb-3">
                <AvField
                  name="itemContentEn"
                  label="Cancelation Policy Content In English"
                  placeholder="Type Something In English"
                  type="text"
                  errorMessage="Enter Content In English"
                  value={updateData.itemContent.en}
                  validate={{ required: { value: true } }}
                  onChange={(e) =>
                    setUpdateData({
                      ...updateData,
                      itemContent: {
                        en: e.target.value,
                        ar: updateData.itemContent.ar,
                      },
                    })
                  }
                />
              </div>
              <div className="mb-3">
                <AvField
                  name="itemContentAr"
                  label="Cancelation Policy Content In Arabic"
                  placeholder="Type Something In Arabic"
                  type="text"
                  errorMessage="Enter Content In Arabic"
                  value={updateData.itemContent.ar}
                  validate={{ required: { value: true } }}
                  onChange={(e) =>
                    setUpdateData({
                      ...updateData,
                      itemContent: {
                        en: updateData.itemContent.en,
                        ar: e.target.value,
                      },
                    })
                  }
                />
              </div>
              <h4 className="card-title">Status</h4>
              <div className="form-check form-switch mb-3" dir="ltr">
                <Input
                  type="checkbox"
                  className="form-check-input"
                  checked={updateData.isChecked}
                  onChange={() =>
                    setUpdateData({
                      ...updateData,
                      isChecked: !updateData.isChecked,
                    })
                  }
                  id="customSwitch1"
                  defaultChecked
                />

                <Label className="form-check-label" htmlFor="customSwitch1">
                  {updateData.isChecked ? "Active" : "Inactive"}
                </Label>
              </div>
            </AvForm>
          </ModalBody>
          <ModalFooter>
            <Button
              type="button"
              onClick={tog_standard}
              color="light"
              className="waves-effect"
            >
              Close
            </Button>
            <Button
              type="button"
              onClick={handleUpdate}
              color="primary"
              className="waves-effect waves-light"
            >
              Save Changes
            </Button>
          </ModalFooter>
        </Modal>
        {/* END: Modal EDIT  */}

        {/* START: Modal DELETE */}
        <Modal isOpen={modal_static} toggle={tog_static} backdrop="static">
          <ModalHeader toggle={tog_static}>Static Backdrop</ModalHeader>
          <ModalBody>
            <p>Are you sure you want to delete this Cancel Policy?</p>
            <ModalFooter>
              <Button type="button" color="light" onClick={tog_static}>
                Close
              </Button>
              <Button type="button" color="primary" onClick={handleDelete}>
                Delete
              </Button>
            </ModalFooter>
          </ModalBody>
        </Modal>
        {/* END: Modal DELETE */}
      </Container>
      </div>
    </React.Fragment>
  );
};

export default CancelationPolicy;
